import { useDispatch } from "react-redux";
import { addFlash, closeFlash, clearFlashes } from "../actions/flashes-actions";

export default function useFlash() {
  const dispatch = useDispatch();

  return (message, options = {}, scrollToTop = false) => {
    if (!message) return () => {};

    if (scrollToTop) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    const flashKey = dispatch(addFlash(message, options)).payload.key;
    return () => dispatch(closeFlash(flashKey));
  };
};

export function useClearFlashes() {
  const dispatch = useDispatch();

  return () => dispatch(clearFlashes());
}
